import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import { WysiwygField, Image } from '@uncinc/uncinc-react-kitchen-sink';
import { dateFormatter, getPathFromAlternativePaths } from '../../../../helpers';

import '../../Article/teaser/style.scss';

const NewsTeaser = ({ showPinned = false, entity, className }) => {
  const classes = classNames(className, 'NewsTeaser');
  const url = getPathFromAlternativePaths(entity, ['news', 'nieuws']);
  const promotedToFrontPage = entity.getIn(['promote', 0, 'value'], false);
  const isPinned = promotedToFrontPage && showPinned;

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="NewsTeaser__content">
        <div className="NewsTeaser__imageWrapper">
          <Image
            alt={entity.getIn(['field_teaser_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_teaser_media', 0, 'styles', 'teaser_large'], '')}
            className="NewsTeaser__imageNormal"
          />
          <Image
            alt={entity.getIn(['field_teaser_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_teaser_media', 0, 'styles', 'large'], '')}
            className="NewsTeaser__imageMobile"
          />
        </div>
        <div className="NewsTeaser__contentWrapper">
          <div className="node--sub-heading node--sub-heading--with-labels">
            {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value']) ? (
              <div className="theme-labels">
                <div className="theme-label">
                  {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], '')}
                </div>
                {entity.getIn(['field_theme']).size > 1 && (
                  <div className="theme-label">
                    +{entity.getIn(['field_theme']).size - 1}
                  </div>
                )}
              </div>
            ) : null}
            <span className={isPinned ? 'pinned' : ''}>{isPinned && (
              <i className="icon icon-pinned icon-variant-4" />
            )}
              {i18next.t('news')}
            </span>
          </div>
          <h3>{entity.getIn(['title', 0, 'value'])}</h3>
          {entity.getIn(['body', 0, 'processed']) ? (
            <div className="NewsTeaser__truncate">
              <WysiwygField
                property="schema:text"
                className="node--page--body"
                html={entity.getIn(['body', 0, 'processed'], '')}
              />
            </div>

          ) : null}
          <div className="NewsTeaser__date">
            {dateFormatter(entity.getIn(['created', 0, 'value'], new Date()))}
          </div>
        </div>
      </div>
    </article>
  );
};

export default NewsTeaser;
